export default "__VITE_ASSET__CwbmsWkz__"